export default "__VITE_ASSET__12a569f0__"